import React from 'react'

const ConfirmOtp = () => {
  return (
    <div>
      <h1>dljfdhfk</h1>
    </div>
  )
}

export default ConfirmOtp
